/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { shadowColor } from 'theme/color';
import { Card, Grid, Typography } from '@mui/material';
import {
  fontsize24,
  fontsize32,
  poppins500,
  poppins400,
  poppins600,
  displayFlex,
  fontsize12,
} from 'theme/common.style';
import CardHeaderContainer from 'component/CardHeaderContainer/CardHeaderContainer';
import place from 'assets/icons/location.svg';
import { alignCenter } from 'component/VendorStatusContainer/VendorStatusContainer.style';
import { color } from 'd3';
import { lineHeight } from '@mui/system';
import { lorem, loco } from './PropertyProfile.style';

function PropertyWalkScore(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid
          sx={{ ...poppins500, ...fontsize24, ...alignCenter }}
          lineHeight="36px"
        >
          Walk Score
        </Grid>
        <Grid
          sx={{ ...poppins400, ...fontsize24, ...displayFlex, ...alignCenter }}
          lineHeight="36px"
        >
          <CardHeaderContainer
            style={loco}
            width="18.63px"
            height="22.62px"
            icon={place}
          />
          1435 Logan St Los Angeles CA 90026 USA
        </Grid>
        <Grid container>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
            }}
          >
            <Grid
              container
              sx={{
                borderRadius: '10px',
                height: 'auto',
                display: 'flex',
                justifyContent: 'center',
                flexDirection: 'row',
                alignItems: 'center',
                backgroundColor: '#F8F8F8',
                padding: '20px',
              }}
            >
              <Grid
                xs={1.5}
                sx={{
                  padding: '10px',

                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  alignItems: 'Left',
                }}
              >
                <Card
                  variant="outlined"
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }}
                >
                  <Typography
                    color="#965CF0"
                    sx={{
                      ...poppins600,
                      ...fontsize32,
                      ...displayFlex,
                      ...alignCenter,
                    }}
                  >
                    95
                  </Typography>
                  <Typography
                    color="#C4C4C4"
                    sx={{
                      ...poppins400,
                      ...fontsize12,

                      ...alignCenter,
                    }}
                  >
                    Walk Score
                  </Typography>
                </Card>
              </Grid>
              <Grid
                item
                xs={10.5}
                sx={{
                  padding: '10px',

                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography
                  color="#000000"
                  sx={{
                    ...poppins500,
                    ...fontsize24,
                    ...displayFlex,
                    ...alignCenter,
                  }}
                >
                  Walker’s Paradise
                </Typography>
                <Typography style={lorem}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyWalkScore.propTypes = {};

export default PropertyWalkScore;
